import React, { useMemo } from 'react';
import { Box, Divider } from '@mui/material';
import DuengePlan from '../../components/DuengePlan';
import { fertApiV4 } from '../../api/duengeplanApi';
import GrowPlanTimelineView from '../components/GrowPlanTimelineView';
import { useGrowSetup } from '../../GrowSetupContext';

function getUserId() {
  try {
    const token = localStorage.getItem('token');
    if (!token) return null;
    return JSON.parse(atob(token.split('.')[1])).sub || null;
  } catch (_) {
    return null;
  }
}

const V4_STYLES = {
  '& .MuiPaper-root,& .MuiCard-root': {
    background: 'rgba(var(--v4-surface-rgb),0.9) !important',
    border: '1px solid rgba(var(--v4-cyan-rgb),0.1) !important',
    borderRadius: '16px !important',
    backdropFilter: 'blur(20px)',
    boxShadow: 'none !important',
  },
  '& .MuiTableHead-root .MuiTableCell-root': {
    background: 'rgba(var(--v4-cyan-rgb),0.06) !important',
    color: 'var(--v4-cyan) !important',
    fontWeight: 700,
    borderBottom: '1px solid rgba(var(--v4-cyan-rgb),0.15) !important',
  },
  '& .MuiTableBody-root .MuiTableCell-root': {
    borderBottom: '1px solid rgba(var(--v4-cyan-rgb),0.05) !important',
    color: 'rgba(var(--v4-muted-rgb),0.8)',
  },
  '& .MuiTableBody-root .MuiTableRow-root:hover': {
    background: 'rgba(var(--v4-cyan-rgb),0.04) !important',
  },
  '& .MuiTypography-root': { color: 'rgba(var(--v4-muted-rgb),0.8)' },
  '& h5,& h6': { color: 'var(--v4-text) !important' },
  '& .MuiInputBase-root': {
    background: 'rgba(var(--v4-cyan-rgb),0.04) !important',
    '& fieldset': { borderColor: 'rgba(var(--v4-cyan-rgb),0.15) !important' },
  },
  '& .MuiButton-contained': {
    background: 'linear-gradient(135deg,var(--v4-cyan),var(--v4-cyan-deep)) !important',
    borderRadius: '10px !important',
    boxShadow: '0 4px 16px rgba(var(--v4-cyan-rgb),0.35) !important',
  },
};

export default function V4GrowPlanPage() {
  const { grow_setup } = useGrowSetup();
  const userId = useMemo(() => getUserId(), []);

  return (
    <Box sx={V4_STYLES}>
      <GrowPlanTimelineView growSetupId={grow_setup || null} userId={userId} />
      <Divider sx={{ borderColor: 'rgba(var(--v4-cyan-rgb),0.1)', my: 3 }} />
      <DuengePlan api={fertApiV4} />
    </Box>
  );
}
